import React, { useEffect, useState } from 'react';

import { Carousel } from '@salesforce/design-system-react';
import { IconSettings } from '@salesforce/design-system-react';

const items = [
  {
    id: 1,
    imageAssistiveText: 'Appy',
    heading: 'Appy',
    src: '/Images/Personas_Shrunken/GettyImages-01.jpg',
  },
  {
    id: 2,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-02.jpg',
  },
  {
    id: 3,
    imageAssistiveText: 'Salesforce Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-03.jpg',
  },
  {
    id: 4,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-04.jpg',
  },
  {
    id: 5,
    imageAssistiveText: 'Appy',
    heading: 'Appy',
    src: '/Images/Personas_Shrunken/GettyImages-05.jpg',
  },
  {
    id: 6,
    imageAssistiveText: 'Salesforce Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-06.jpg',
  },
  {
    id: 7,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-07.jpg',
  },
  {
    id: 8,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-08.jpg',
  },
  {
    id: 9,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-09.jpg',
  },
  {
    id: 10,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-10.jpg',
  },
  {
    id: 11,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-11.jpg',
  },
  {
    id: 12,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-12.jpg',
  },
  {
    id: 13,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-13.jpg',
  },
  {
    id: 14,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-14.jpg',
  },
  {
    id: 15,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-15.jpg',
  },
  {
    id: 16,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-16.jpg',
  },
  {
    id: 17,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-17.jpg',
  },
  {
    id: 18,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-18.jpg',
  },
  {
    id: 20,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-20.jpg',
  },
  {
    id: 21,
    imageAssistiveText: 'Apps',
    heading: 'Apps',
    src: '/Images/Personas_Shrunken/GettyImages-21.jpg',
  },
];

const PersonaCarousel = (props) => { 
  const [starterScreen, setStarterScreen] = useState(0);

  useEffect(() => { 
    for(let i = 0; i < items.length; i++){
      if(items[i].src === props.picUrl){
        setStarterScreen(i);
      }
    }
  }, [props.picUrl]);

  const changeCarousel = (event, data) => {
    setStarterScreen(data.requestedPanel);
  }

  return (
    <IconSettings iconPath="/icons">
      <div
        style={{
          margin: '0 auto',
          maxWidth: '774px',
        }}
      >
        <Carousel
          currentPanel={starterScreen}
          hasPreviousNextPanelNavigation
          className="carousel"
          items={items}
          itemsPerPanel={1}
          onItemClick={props.onPicSelect}
          onRequestPanelChange={changeCarousel}
        />
      </div>
    </IconSettings>
  );
}

export default PersonaCarousel;
